export const BASE_URL = import.meta.env.VITE_API_URL

export const PUBLIC_ENDPOINTS = {
  website: {
    help: '/mail/help',
    forgotPassword: '/mail/forgotPassword',
  },
}

export const PRIVATE_ENDPOINTS = {
  auth: {
    login: '/auth/login',
  },

  user: {
    create: '/utente',
    all: '/utente',
    single: (id: number) => `/utente/${id}`,
    update: (id: number) => `/utente/${id}`,
    delete: (id: number) => `/utente/${id}`,
  },

  customer: {
    create: '/cliente',
    all: '/cliente',
    single: (id: number) => `/cliente/${id}`,
    update: (id: number) => `/cliente/${id}`,
    delete: (id: number) => `/cliente/${id}`,
  },

  profilo: {
    create: '/profilo',
    all: '/profilo',
    single: (id: number) => `/profilo/${id}`,
    update: (id: number) => `/profilo/${id}`,
    delete: (id: number) => `/profilo/${id}`,
  },

  numerazione: {
    create: '/numerazione',
    all: '/numerazione',
    single: (id: number) => `/numerazione/${id}`,
    update: (id: number) => `/numerazione/${id}`,
    delete: (id: number) => `/numerazione/${id}`,
  },

  cantiere: {
    create: '/cantiere',
    all: '/cantiere',
    single: (id: number) => `/cantiere/${id}`,
    update: (id: number) => `/cantiere/${id}`,
    delete: (id: number) => `/cantiere/${id}`,
  },

  parco: {
    create: '/parco',
    all: '/parco',
    single: (id: number) => `/parco/${id}`,
    update: (id: number) => `/parco/${id}`,
    delete: (id: number) => `/parco/${id}`,
  },

  vettura: {
    create: '/vettura',
    all: '/vettura',
    single: (id: number) => `/vettura/${id}`,
    update: (id: number) => `/vettura/${id}`,
    delete: (id: number) => `/vettura/${id}`,
    statistiche: '/vettura/statistiche',
    dashboardStats: '/vettura/dashboard-stats',
    bulkApprove: '/vettura/bulk-approve',

    downloadFoto: (id: number) => `/vettura/${id}/getFoto`,
    uploadFoto: (id: number) => `/vettura/${id}/foto`,
    downloadFirma: (id: number) => `/vettura/${id}/getFirma`,
  },

  job: {
    create: '/job',
    all: '/job',
    single: (id: number) => `/job/${id}`,
    update: (id: number) => `/job/${id}`,
    delete: (id: number) => `/job/${id}`,
  },

  fattura: {
    create: '/fattura',
    all: '/fattura',
    single: (id: number) => `/fattura/${id}`,
    update: (id: number) => `/fattura/${id}`,
    delete: (id: number) => `/fattura/${id}`,

    regenerate: (id: number) => `/fattura/${id}/regenerate`,
    notaCredito: (id: number) => `/fattura/${id}/nota-credito`,
    uploadPdf: (id: number) => `/fattura/${id}/upload-pdf`,
    downloadPdf: (id: number) => `/fattura/${id}/pdf`,
    statistiche: '/fattura/statistiche',
  }

}
